import React, { useEffect, useState } from 'react';
import {
    notification,
    Skeleton,
    Typography,
} from 'antd';

import { useTranslation } from 'react-i18next';
import { AuthConsumer } from 'shared/contexts/AuthContext';
import {useHistory} from 'react-router-dom';
import FrontendSidebar from 'views/FrontendSidebar/FrontendSidebar';
import API_SERVICE from 'shared/services/api-service';
import Parameters from 'shared/parameters';
import LockImg from "../../img/closed-lock.png";
interface Props {
    location: any;
}

const { Title } = Typography;
export default function FrontendMyBadges(props: Props) {
    const { t } = useTranslation();
  const history = useHistory();
  const user = JSON.parse(localStorage.getItem('auth-token') as string)?.user;
  const [badges, setBadges] = useState([] as any[]);
  const [myBadges, setMyBadges] = useState([] as any[]);
  const [fetching, setFetching] = useState(false as boolean);
  const [totalBadges, setTotalBadges] = useState("" as any);
  const [gainBadges, setGainBadges] = useState("" as any);
  var arr: any = [];
console.log('arr',arr);

  const BadgeComponent = () => {
    const params: any = { order_by: 'id', order: 'ASC' }
    setFetching(true);
        API_SERVICE.getMyBadges(params).then(({ data: { data } }) => {
            setBadges(data.badges.items);
            setMyBadges(data.user_badges.items);
            setTotalBadges(data.badges.count)
            setGainBadges(data.user_badges.count)
            console.log('badgesssss',data.user_badges)
            setFetching(false);
        }).catch((e: any) => {
            notification.error({ message: t(API_SERVICE.handleErrors(e)) });
            setFetching(false);
        });
    }
    useEffect(() => {
        BadgeComponent();
    },[]);
    if(fetching){
        return <Skeleton active={true}/>
    }
    return (
        <div className={'profile-wrapper container-fluid pl-0 pr-0'}>
            <AuthConsumer>
                {({ isAuth, updateUser, cartTime, cart, user }) => (
                    <>
                    <div className='d-md-flex'>
                        
                        <FrontendSidebar menuSelect={6} />
                        
                        <div className={'profile-tab-content-div pl-3 pr-3 mb-3'} style={{width: '100%'}}>
                            <div className='myBadgeSection'>
                            <div className="row">
		      <div className="col-md-12">
		         <div className="bg-white p-3 br-5px pos-relative">
		            <div className="text-center">
		            	<h3 className="text-center">{t('genDict.YourBadge')} {gainBadges}/{totalBadges}</h3>
		            </div>
		            <div className="row plr-4rem justify-content-center">
                    {myBadges && myBadges.map((myBadge:any) => {
                            return <div className="col-lg-4 col-md-4 col-sm-4 mt-5 text-center">
                                <img src={Parameters.ImageBaseUrl + myBadge.badge.image.slug + myBadge.badge.image.ext} className="badges orange-badge"/>
                                <p className="text-center InterMedium">{myBadge.badge.title}</p>
                                <span className='d-none'>{arr.push(myBadge.badge.id)}</span>
                            </div>
                        })}
                        {badges && badges.map((badge:any) => {
                            return <>
                            {arr.indexOf(badge.id) > -1 ? <></> :
                            <div className="col-lg-4 col-md-4 col-sm-4 mt-5 text-center">
                                <img src={LockImg} className="badges-lock"/>
                                <p className="text-center InterMedium">{badge.title}</p>
                            </div>}
                            </>
                        })}
		            	{/* <div className="col-lg-4 col-md-4 col-sm-4 mt-5 text-center">
		            		<img src="assets/img/student-badge.png" className="badges orange-badge"/>
		            		<p className="text-center InterMedium">Orange Badge</p>
		            	</div>
		            	<div className="col-lg-4 col-md-4 col-sm-4 mt-5 text-center">
		            		<img src="assets/img/closed-lock.png" className="badges-lock"/>
		            		<p className="text-center InterMedium">Yellow Badge</p>
		            	</div>
		            	<div className="col-lg-4 col-md-4 col-sm-4 mt-5 text-center">
		            		<img src="assets/img/closed-lock.png" className="badges-lock"/>
		            		<p className="text-center InterMedium">Bronze Badge</p>
		            	</div> */}
		            </div>
		            {/* <div className="row plr-12">
		            	<div className="col-lg-6 col-md-6 col-sm-6 mt-5 text-center">
		            		<img src="assets/img/closed-lock.png" className="badges-lock"/>
		            		<p className="text-center InterMedium">Silver Badge</p>
		            	</div>
		            	<div className="col-lg-6 col-md-6 col-sm-6 mt-5 text-center">
		            		<img src="assets/img/closed-lock.png" className="badges-lock"/>
		            		<p className="text-center InterMedium">Gold Badge</p>
		            	</div>
		            </div> */}
		         </div>
		      </div>
		   </div>
                            </div>
                        </div>
                    </div>
                    </>
                )}
            </AuthConsumer>
        </div>
    );
}
